/**
 * Delivery status of a marketing contact's email.
 *
 * demoslides records email_status when the email is sent ("sent" or
 * "failed") and updates it from Resend's webhook afterwards (delivered,
 * delayed, bounced, spam complaint, suppressed). Contacts emailed before
 * tracking started have no email_status, so they fall back to email_sent.
 */

const TRACKED_STATUSES = {
  failed: { label: "Send Failed", badgeClass: "bg-danger", problem: true },
  bounced: { label: "Bounced", badgeClass: "bg-danger", problem: true },
  complained: { label: "Marked as Spam", badgeClass: "bg-danger", problem: true },
  suppressed: { label: "Suppressed", badgeClass: "bg-danger", problem: true },
  delayed: { label: "Delivery Delayed", badgeClass: "bg-warning text-dark", problem: false },
  delivered: { label: "Delivered", badgeClass: "bg-success", problem: false },
  sent: { label: "Email Sent", badgeClass: "bg-success", problem: false },
};

const SENT = TRACKED_STATUSES.sent;
const NOT_SENT = { label: "Email Not Sent", badgeClass: "bg-warning text-dark", problem: false };

/**
 * Returns { label, badgeClass, problem, detail } for the Email Status badge.
 *
 * Problems always show, even with Email Sent unchecked: a failed send never
 * sets it, and after a bounce an admin may uncheck it to resend once the
 * address is fixed. Other tracked statuses only show while the contact is
 * marked sent, so unchecking Email Sent still reads as "Email Not Sent".
 */
export const getEmailStatus = (contact) => {
  const tracked = TRACKED_STATUSES[contact.email_status];
  if (tracked && (tracked.problem || contact.email_sent)) {
    return { ...tracked, detail: contact.email_status_detail || "" };
  }
  return { ...(contact.email_sent ? SENT : NOT_SENT), detail: "" };
};
